import { render, staticRenderFns } from "./QNoticesAuthorSwitch.vue?vue&type=template&id=310cc07f&scoped=true&"
import script from "./QNoticesAuthorSwitch.vue?vue&type=script&lang=ts&"
export * from "./QNoticesAuthorSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./QNoticesAuthorSwitch.vue?vue&type=style&index=0&id=310cc07f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310cc07f",
  null
  
)

export default component.exports